import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { fetchClient, formatHeaders } from '@nike/fetch-client';
import { NIKECOM_CHANNEL, DOTCOM_UX_ID } from '@nike/ux-tread-dotcom-constants';
import getPartnerCartPreorderQueryKey from './get-query-key';
import getWebShellClientLocale from "../../../../utils/get-webshellclient-locale";
import getFetchCartOptions from "../../carts/v2/fetch/get-options";
export var getPartnerCartPreorderJob = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var id, token, _yield$window$webShel, visitorId, visitId;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          id = _ref.id;
          _context.next = 1;
          return window.webShellClient.identity.getAccessToken();
        case 1:
          token = _context.sent;
          _context.next = 2;
          return window.webShellClient.identity.getVisitData();
        case 2:
          _yield$window$webShel = _context.sent;
          visitorId = _yield$window$webShel.visitorId;
          visitId = _yield$window$webShel.visitId;
          return _context.abrupt("return", fetchClient("".concat(process.env.NEXT_PUBLIC_API_HOST_NAME, "/buy/partner_cart_preorder_jobs/v2/").concat(id), {
            method: 'GET',
            credentials: 'include',
            headers: formatHeaders({
              token: token,
              visitId: visitId,
              visitorId: visitorId,
              appId: DOTCOM_UX_ID
            })
          }, 'Error retrieving Partner Cart.', {
            pageActionName: 'partnercart-event'
          }));
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getPartnerCartPreorderJob(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export var putPartnerCartPreorder = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
    var paypalClicked, id, queryClient, _getWebShellClientLoc, langRegion, country, token, _yield$window$webShel2, visitorId, visitId, _yield$queryClient$fe, cartId, currency, items;
    return _regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          paypalClicked = _ref3.paypalClicked, id = _ref3.id, queryClient = _ref3.queryClient;
          _getWebShellClientLoc = getWebShellClientLocale(), langRegion = _getWebShellClientLoc.langRegion, country = _getWebShellClientLoc.country;
          _context2.next = 1;
          return window.webShellClient.identity.getAccessToken();
        case 1:
          token = _context2.sent;
          _context2.next = 2;
          return window.webShellClient.identity.getVisitData();
        case 2:
          _yield$window$webShel2 = _context2.sent;
          visitorId = _yield$window$webShel2.visitorId;
          visitId = _yield$window$webShel2.visitId;
          _context2.next = 3;
          return queryClient.fetchQuery(getFetchCartOptions({
            queryClient: queryClient
          }));
        case 3:
          _yield$queryClient$fe = _context2.sent;
          cartId = _yield$queryClient$fe.id;
          currency = _yield$queryClient$fe.currency;
          items = _yield$queryClient$fe.items;
          return _context2.abrupt("return", fetchClient("".concat(process.env.NEXT_PUBLIC_API_HOST_NAME, "/buy/partner_cart_preorder/v2/").concat(id), {
            method: 'PUT',
            credentials: 'include',
            headers: formatHeaders({
              token: token,
              visitId: visitId,
              visitorId: visitorId,
              appId: DOTCOM_UX_ID
            }),
            body: JSON.stringify({
              country: country.toUpperCase(),
              language: langRegion,
              channel: NIKECOM_CHANNEL,
              cartId: cartId,
              currency: currency,
              paypalClicked: paypalClicked,
              items: items
            })
          }, 'Error creating link to Partner Cart.', {
            pageActionName: 'tread-partnercart-event'
          }));
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function putPartnerCartPreorder(_x2) {
    return _ref4.apply(this, arguments);
  };
}();
export var createPartnerCartPreorder = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5) {
    var paypalClicked, id, queryClient, MAX_TIMEOUT, timeNow, timeoutTime, response, _t;
    return _regeneratorRuntime.wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          paypalClicked = _ref5.paypalClicked, id = _ref5.id, queryClient = _ref5.queryClient;
          _context3.prev = 1;
          _context3.next = 2;
          return putPartnerCartPreorder({
            paypalClicked: paypalClicked,
            id: id,
            queryClient: queryClient
          });
        case 2:
          _context3.next = 4;
          break;
        case 3:
          _context3.prev = 3;
          _t = _context3["catch"](1);
          if (window.newrelic && window.newrelic.addPageAction) {
            window.newrelic.addPageAction('partner-cart-preorder-error', {
              message: _t.message,
              error: _t
            });
          }
          return _context3.abrupt("return");
        case 4:
          // This is for CQRS call for services.
          // We have a timeout of 30 seconds to wait for the job to complete
          // If the job is not completed in that time, we throw an error
          MAX_TIMEOUT = 30000;
          timeNow = Date.now();
          timeoutTime = Date.now() + MAX_TIMEOUT; // timeNow tracks the current time in milliseconds and is updated in the loop
        case 5:
          _context3.next = 6;
          return getPartnerCartPreorderJob({
            id: id
          });
        case 6:
          response = _context3.sent;
          if (!(response.status !== 'COMPLETED')) {
            _context3.next = 8;
            break;
          }
          _context3.next = 7;
          return new Promise(function (resolve) {
            return setTimeout(resolve, 200);
          });
        case 7:
          // Wait for 200ms before updating time
          timeNow = Date.now();
          _context3.next = 9;
          break;
        case 8:
          return _context3.abrupt("return", response);
        case 9:
          if (timeNow < timeoutTime) {
            _context3.next = 5;
            break;
          }
        case 10:
          throw new Error({
            message: 'Partner Cart Preorder job did not complete within the timeout period.',
            error: null
          });
        case 11:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[1, 3]]);
  }));
  return function createPartnerCartPreorder(_x3) {
    return _ref6.apply(this, arguments);
  };
}();
var getPartnerCartPreorderOptions = function getPartnerCartPreorderOptions(_ref7) {
  var paypalClicked = _ref7.paypalClicked,
    queryClient = _ref7.queryClient;
  // Define job id here so we can use it in the query key and in the query functions
  var id = window.crypto.randomUUID();

  // eslint-disable-next-line @tanstack/query/exhaustive-deps
  return {
    queryKey: getPartnerCartPreorderQueryKey({
      paypalClicked: paypalClicked,
      id: id
    }),
    queryFn: function queryFn() {
      return createPartnerCartPreorder({
        paypalClicked: paypalClicked,
        id: id,
        queryClient: queryClient
      });
    },
    onError: function onError(error) {
      if (window.newrelic && window.newrelic.addPageAction) {
        window.newrelic.addPageAction('partner_cart_preorder/v2-error', {
          message: error.message,
          error: error
        });
      }
    }
  };
};
export default getPartnerCartPreorderOptions;